import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import InputWrapper from "../../../layout/inputWrapper";
import ButtonWrapper from "../../../components/Button";
import { Col, Container, Row } from "react-bootstrap";
import { nameSuffix, qualificationTypeList } from "../../../../TCPForms/data";
import dayjs from "dayjs";
import SortingAlphabatically from "../../../reusableComponents/SortingAlphbatically";
import { Toast } from "@egovernments/digit-ui-react-components";

const SubStep2 = ({ formData, handleSubTabChange, isEmployee, isReapply }) => {
  const [showToast, setShowToast] = useState(null);
  const { t } = useTranslation();
  const today = dayjs();
  const eighteenYearsAgo = today.subtract(18, "year");
  const registrationType = formData?.registrationType;

  const defaultValues = {
    ...formData,
    tradeLicenseDetail: {
      ...formData?.tradeLicenseDetail,
      owners: [
        {
          ...formData?.tradeLicenseDetail?.owners?.[0],
          initialForApplicantName: formData?.tradeLicenseDetail?.owners?.[0]?.initialForApplicantName || "Mr.",
        },
      ],
    },
  };
  const { handleSubmit, watch, setValue, control } = useForm({ defaultValues });
  const watchEducationalQualification = watch("tradeLicenseDetail.owners.[0].qualification");
  const panNo = watch("tradeLicenseDetail.owners.[0].pan");
  useEffect(() => {
    const capitalizePAN = panNo?.toUpperCase();
    setValue("tradeLicenseDetail.owners.[0].pan", capitalizePAN);
  }, [panNo]);

  const onSubmit = (data) => {
    const dob = data?.tradeLicenseDetail?.owners?.[0]?.dateOfBirth;
    const experienceRaw = data?.tradeLicenseDetail?.owners?.[0]?.totalExperience;

    if (dob && experienceRaw) {
      const birthDate = dayjs(dob);
      const today = dayjs();
      const age = today.diff(birthDate, "year");

      const minWorkingAge = 18;
      const maxAllowedExperience = age - minWorkingAge;

      let years = 0,
        months = 0;
      const match = experienceRaw.match(/(\d+)\s*Years?-?\s*(\d+)\s*Months?/i);
      if (match) {
        years = Number(match[1]) || 0;
        months = Number(match[2]) || 0;
      } else {
        setShowToast({ key: true, label: "Invalid Experience Format" });
        return;
      }

      const totalExperienceInYears = years + months / 12;

      if (totalExperienceInYears > maxAllowedExperience) {
        setShowToast({ key: true, label: "Experience is not valid according to DOB" });
        return;
      }

      if (registrationType === "Supervisor" && watchEducationalQualification === "Diploma in Civil Engineering" && totalExperienceInYears < 5) {
        setShowToast({ key: true, label: "Minimum experience should be 5 years for Diploma in Diploma in Civil Engineering Qualification" });
        return;
      }
    }

    data.tradeLicenseDetail.owners[0].gender = data?.tradeLicenseDetail?.owners?.[0]?.initialForApplicantName === "Mr." ? "MALE" : "FEMALE";
    data.tradeLicenseDetail.owners[0].name = `${data?.tradeLicenseDetail?.owners?.[0]?.name}` || null;

    handleSubTabChange(2, data); // ✅ Submit
  };

  return (
    <section className="groupContainer2">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="formContainer">
          <div className="formContainer">
            <div className="formHeaderContainer">
              <h2 className="formHeading">{t("LABEL_APPLICANT_DETAILS")}</h2>
            </div>
            <Container fluid className="formInputContainer common-app-form">
              <Row>
                <Col>
                  <InputWrapper
                    label={t("LABEL_APPLICANT_NAME")}
                    control={control}
                    placeholder={t("LABEL_ENTER_NAME")}
                    name="tradeLicenseDetail.owners.[0].name"
                    mandatory
                    maxLength={70}
                    defaultValue={formData?.tradeLicenseDetail?.owners?.[0]?.name}
                    type="textInput"
                    disabled={isEmployee || (isReapply && formData?.tradeLicenseDetail?.owners?.[0]?.name)}
                    validation={
                      {
                        // required: {
                        //   value: true,
                        //   message: "This field is required",
                        // },
                        // pattern: {
                        //   value: Digit.Utils.getPattern("Name"),
                        //   message: "Please enter only letters and spaces",
                        // },
                      }
                    }
                    selectSuffix={{
                      name: `tradeLicenseDetail.owners.[0].initialForApplicantName`,
                      data: SortingAlphabatically(nameSuffix),
                      defaultValue: formData?.tradeLicenseDetail?.owners?.[0]?.initialForApplicantName || "Mr.",
                      control,
                      disabled: isEmployee || (isReapply && formData?.tradeLicenseDetail?.owners?.[0]?.initialForApplicantName),
                    }}
                  />
                </Col>
                <Col>
                  <InputWrapper
                    label={t("LABEL_TOTAL_EXPERIENCE")}
                    control={control}
                    placeholder={t("LABEL_ENTER_EXPERIENCE")}
                    name="tradeLicenseDetail.owners.[0].totalExperience"
                    type="yearMonthPicker"
                    defaultValue={formData?.tradeLicenseDetail?.owners?.[0]?.totalExperience}
                    disabled={isEmployee || (isReapply && formData?.tradeLicenseDetail?.owners?.[0]?.totalExperience)}
                  />
                </Col>
              </Row>

              <Row>
                <Col>
                  <InputWrapper
                    label={t("LABEL_EDUCATIONAL_QUALIFICATION")}
                    control={control}
                    placeholder={t("Select Qualification")}
                    name="tradeLicenseDetail.owners.[0].qualification"
                    mandatory
                    disabled={isEmployee || (isReapply && formData?.tradeLicenseDetail?.owners?.[0]?.qualification)}
                    data={SortingAlphabatically(qualificationTypeList.filter((e) => e.type === registrationType))}
                    maxLength={50}
                    defaultValue={formData?.tradeLicenseDetail?.owners?.[0]?.qualification}
                    type="selectInput"
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
                <Col>
                  <InputWrapper
                    label="Aadhaar Number"
                    control={control}
                    placeholder="Enter Aadhaar Number"
                    name="tradeLicenseDetail.owners.[0].aadhaarNumber"
                    defaultValue={formData?.tradeLicenseDetail?.owners?.[0]?.aadhaarNumber}
                    disabled={isEmployee || (isReapply && formData?.tradeLicenseDetail?.owners?.[0]?.aadhaarNumber)}
                    type="textInput"
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                      pattern: {
                        value: Digit.Utils.getPattern("AadharNo"),
                        message: "Please enter valid Aadhaar no",
                      },
                    }}
                    maxLength={12}
                  />
                </Col>
              </Row>

              <Row>
                <Col>
                  <InputWrapper
                    label={t("LABEL_FIRM_NAME")}
                    control={control}
                    placeholder={t("LABEL_ENTER_FIRM_NAME")}
                    name="tradeLicenseDetail.owners.[0].firmName"
                    defaultValue={formData?.tradeLicenseDetail?.owners?.[0]?.firmName}
                    disabled={isEmployee || (isReapply && formData?.tradeLicenseDetail?.owners?.[0]?.firmName)}
                    maxLength={50}
                    height={40}
                    type="textInput"
                    validation={{
                      pattern: {
                        value: Digit.Utils.getPattern("NonSpecialCharsOnly"),
                        message: "Please enter valid Characters",
                      },
                    }}
                  />
                </Col>
                <Col>
                  <InputWrapper
                    label={t("LABEL_DATE_OF_BIRTH")}
                    mandatory
                    control={control}
                    placeholder="Select Date"
                    name="tradeLicenseDetail.owners.[0].dateOfBirth"
                    defaultValue={formData?.tradeLicenseDetail?.owners?.[0]?.dateOfBirth}
                    disabled={isEmployee || (isReapply && formData?.tradeLicenseDetail?.owners?.[0]?.dateOfBirth)}
                    type="datePicker"
                    maxDate={eighteenYearsAgo}
                    disableFuture={true}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                      pattern: {
                        value: Digit.Utils.getPattern("Date"),
                        message: "Please enter valid date",
                      },
                    }}
                  />
                </Col>
              </Row>

              <Row>
                <Col>
                  <InputWrapper
                    label={t("LABEL_PAN_NUMBER")}
                    control={control}
                    placeholder={`${t("LABEL_ENTER_PAN_CARD_NO")}`}
                    type="textInput"
                    name="tradeLicenseDetail.owners.[0].pan"
                    defaultValue={formData?.tradeLicenseDetail?.owners?.[0]?.pan}
                    disabled={isEmployee || (isReapply && formData?.tradeLicenseDetail?.owners?.[0]?.pan)}
                    maxLength={10}
                    validation={{
                      pattern: {
                        value: Digit.Utils.getPattern("PAN"),
                        message: "Please enter valid PAN NO",
                      },
                    }}
                  />
                </Col>
                <Col>
                  <InputWrapper
                    label={t("LABEL_NATIONALITY")}
                    control={control}
                    placeholder={t("LABEL_ENTER_NATIONALITY")}
                    name="tradeLicenseDetail.owners.[0].nationality"
                    defaultValue={formData?.tradeLicenseDetail?.owners?.[0]?.nationality || "Indian"}
                    disabled={isEmployee || (isReapply && formData?.tradeLicenseDetail?.owners?.[0]?.nationality)}
                    maxLength={50}
                    type="textInput"
                    validation={{
                      pattern: {
                        value: Digit.Utils.getPattern("Nationality"),
                        message: "Please enter valid Nationality",
                      },
                    }}
                  />
                </Col>
              </Row>

              {/* <InputWrapper
                                    label={t("LABEL_SHORT_PROFILE")}
                                    control={control}
                                    placeholder={t("LABEL_ENTER_PROFILE_SUMMARY")}
                                    name="tradeLicenseDetail.owners.[0].profileSummary"
                                    defaultValue={formData?.tradeLicenseDetail?.owners?.[0]?.profileSummary}
                                    maxLength={100}
                                    type="textInput"
                                /> */}
            </Container>
          </div>
        </div>
        {!isEmployee && (
          <div className="footerContainer">
            <div className="buttonWrapper">
              <ButtonWrapper
                variant="contained"
                color="error"
                size="medium"
                label="Prev"
                sx={{ backgroundColor: "#CCC" }}
                onClick={() => handleSubTabChange(0)}
              />
              <ButtonWrapper variant="contained" color="success" size="medium" label="Save" type="submit" sx={{ backgroundColor: "#157CB3" }} />
            </div>
          </div>
        )}
      </form>

      {showToast && (
        <Toast
          isDleteBtn={true}
          error={showToast.key}
          label={t(showToast.label)}
          onClose={() => {
            setShowToast(null);
          }}
        />
      )}
    </section>
  );
};

export default SubStep2;
